import WarningIcon from '~/assets/icons/Warning';

export default function ErrorBanner({ error }: { error: string }) {
  return (
    <p className="flex w-full items-center gap-2 rounded-lg bg-red-alert/10 p-2 text-sm font-normal text-red-alert">
      <span className="w-6">
        <WarningIcon fill="#D71225" />
      </span>
      {error}
    </p>
  );
}
